import {
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateTimeToPersianDateTime, RaikoBaseCardContainer,
    RaikoGridOneColumn, RaikoTableTitleContainer,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";
import {useAuthState} from "../../../context/AuthContext";
import {LoanRequestsService} from "../../../serverService/loanRequests/LoanRequestsService";
import React, {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {Skeleton} from "@mui/lab";
import {css} from "@emotion/css";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator,
    RaikoCardInfoTypeOneStatusTypes
} from "../../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";

export default function LoanRequestDetailInstallments() {

    const {fundID} = useAuthState()
    const {id: loanRequestId} = useParams()

    const service = new LoanRequestsService()

    const [installments, setInstallments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getInstallments()
    }, []);

    function getInstallments() {
        setLoading(true)
        service.getLoanRequestInstallments(
            fundID, loanRequestId
        ).then(response => {
            setInstallments(response.installments)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setLoading(false)
        })
    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"اقساط"}
                        amount={installments.length}
                    />
                    {
                        loading ?
                            [...Array(5)].map(item => {
                                return <Skeleton variant="rectangular" className={css`padding: 90px`}/>
                            }) :
                            installments.map((item, index) => {
                                return <RaikoCardInfoTypeOne
                                    key={`cardOne-${index}`}
                                    title={index + 1}
                                    titleLabel={"شماره قسط"}
                                    items={[
                                        RaikoCardInfoTypeOneItemGenerator("سررسید", convertUniversalDateTimeToPersianDateTime(item.date)),
                                        RaikoCardInfoTypeOneItemGenerator("مبلغ (ریال)", convertCurrencyFormatPositiveNegative(item.amount)),
                                        RaikoCardInfoTypeOneItemGenerator("کارمزد (ریال)", convertCurrencyFormatPositiveNegative(item.amountOfCommission)),
                                        RaikoCardInfoTypeOneItemGenerator("مجموع پرداختی (ریال)", convertCurrencyFormatPositiveNegative(item.payableAmount)),
                                        RaikoCardInfoTypeOneItemGenerator("مبلغ کمکی (ریال)",
                                            item.includesAuxiliaryAmount ? convertCurrencyFormatPositiveNegative(item.auxiliaryAmount) : "ندارد"),
                                    ]}
                                />
                            })
                    }

                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}
